<template>
  <div>
    <v-btn color="grey" icon @click="openDialog = true">
      <v-icon dense>mdi-pencil</v-icon>
    </v-btn>

    <v-dialog v-model="openDialog" max-width="650" persistent>
      <v-card>
        <v-toolbar color="indigo" dark>
          <v-toolbar-title>
            Adı {{ currentLead.user.name ? "Güncelle" : "Ekle" }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-form ref="form" v-model="isFormValid">
          <v-card-text>
            <v-text-field
              v-model.lazy.trim="name"
              hide-details="auto"
              label="Ad Soyad"
              dense
              :rules="[
                (v) => !!v || 'Boş bırakılamaz',
                (v) => v.length >= 3 || 'En az 3 karakter',
              ]"
              required
            />
          </v-card-text>

          <v-card-actions class="d-flex justify-content-end">
            <v-btn color="error" class="mr-2" @click="close">İptal</v-btn>
            <v-btn color="primary" :disabled="!isFormValid" @click="saveName">
              Kaydet
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "EditUserNameModal",
  props: {
    currentLead: Object,
  },
  data() {
    return {
      openDialog: false,
      name: this.currentLead?.user?.name || "",
      isFormValid: true,
    };
  },
  methods: {
    close() {
      this.openDialog = false;
    },
    async saveName() {
      const valid = this.$refs.form.validate();
      if (!valid) return;

      try {
        const { data } = await this.$apiService.put(
          `/users/${this.currentLead.user.id}/update-name`,
          { name: this.name }
        );

        this.$toast.success("Kullanıcı başarıyla güncellendi", {
          duration: 2000,
          position: "bottom-right",
        });

        this.$emit("saved", data.name); // parent'a bildir
        this.close();
      } catch (err) {
        this.$toast.error("İşlem sırasında hata oluştu", {
          duration: 2000,
          position: "bottom-right",
        });
      }
    },
  },
};
</script>
